// extracted by mini-css-extract-plugin
export default {"nav-list":"Navigation-list_nav-list__wn1vv","nav-list-start":"Navigation-list_nav-list-start__2MScU","nav-list-end":"Navigation-list_nav-list-end__shv2p"};